import NotFooterLayout from "layouts/NotFooterLayout";
import CreateProduct from "components/ManageProduct/CreateProduct";
import { useParams } from "react-router-dom";

function CreateProductPage() {
  // มี id = เข้ามาจากปุ่ม "คัดลอกสินค้า" → กรอกฟอร์มจากสินค้าต้นฉบับให้ก่อน
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <NotFooterLayout namePage={id ? "คัดลอกสินค้า" : "เพิ่มสินค้า"}  >
        <div className="layout-content">
          <CreateProduct cloneFromId={id} />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default CreateProductPage;
